// Dependencies
import {
  USUARIOS_REQUEST,
  USUARIOS_REFRESH,
  USUARIOS_OK,
  USUARIOS_ERROR,
} from "./types";
import { get } from "../../../../api/apiInstance";

const fetchUsuarios = () => async (dispatch) => {
  try {
    const response = await get("/usuarios");
    const data = response["data"];
    dispatch({
      type: USUARIOS_OK,
      payload: { data: data["data"], qty: data["rowsAffected"] },
    });
    return Promise.resolve();
  } catch (error) {
    dispatch({ type: USUARIOS_ERROR, payload: error });
    return Promise.reject();
  }
};

export const getUsuarios = () => (dispatch) => {
  dispatch({ type: USUARIOS_REQUEST });
  return dispatch(fetchUsuarios());
};

export const refreshUsuarios = () => (dispatch) => {
  dispatch({ type: USUARIOS_REFRESH });
  return dispatch(fetchUsuarios());
};
